import { Pipe, PipeTransform } from '@angular/core';

/**
 * Maps backend project status values to the labels shown in the UI.
 * Keeps the underlying status value intact for comparisons/logic.
 */
@Pipe({
  name: 'projectStatusLabel',
  standalone: true
})
export class ProjectStatusLabelPipe implements PipeTransform {
  transform(status?: string | null): string {
    if (!status) return '';

    const normalizedStatus = status.trim();

    switch (normalizedStatus) {
      case 'Activo':
        return 'Abierto';
      case 'Financiado':
        return 'En curso';
      default:
        return normalizedStatus;
    }
  }
}
